var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolid0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24316 7.74998C1.24316 7.47384 1.46701 7.24998 1.74315 7.24998H4.49313C4.76927 7.24998 4.99313 7.47384 4.99313 7.74998C4.99313 8.02612 4.76927 8.24997 4.49313 8.24997H1.74315C1.46701 8.24997 1.24316 8.02612 1.24316 7.74998Z",
    fill: "#0060CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.493164 5C0.493164 4.72386 0.71702 4.5 0.99316 4.5H3.24314C3.51928 4.5 3.74314 4.72386 3.74314 5C3.74314 5.27614 3.51928 5.5 3.24314 5.5H0.99316C0.71702 5.5 0.493164 5.27614 0.493164 5Z",
    fill: "#0060CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49316 2.25002C1.49316 1.97388 1.71701 1.75003 1.99315 1.75003H4.49313C4.76927 1.75003 4.99313 1.97388 4.99313 2.25002C4.99313 2.52616 4.76927 2.75002 4.49313 2.75002H1.99315C1.71701 2.75002 1.49316 2.52616 1.49316 2.25002Z",
    fill: "#0060CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67688 0.0350447C8.89045 0.119456 9.01906 0.338491 8.98871 0.566119L8.56419 3.75001H10.4658C10.4715 3.75001 10.4773 3.75001 10.4831 3.75001C10.5934 3.74998 10.7078 3.74996 10.8023 3.7586C10.8953 3.7671 11.0644 3.78962 11.2155 3.90628C11.3918 4.04234 11.4985 4.24969 11.5068 4.47221C11.5138 4.66303 11.4339 4.81372 11.3868 4.8943C11.3389 4.97621 11.2724 5.06928 11.2082 5.15907C11.2048 5.16376 11.2015 5.16844 11.1982 5.17311L7.89997 9.79058C7.76649 9.97745 7.52289 10.0494 7.30932 9.96496C7.09575 9.88054 6.96714 9.66151 6.9975 9.43388L7.42201 6.24999H5.5204C5.51466 6.24999 5.50891 6.24999 5.50315 6.24999C5.39278 6.25002 5.27839 6.25004 5.18389 6.2414C5.09094 6.2329 4.92184 6.21038 4.77068 6.09372C4.5944 5.95766 4.48769 5.75031 4.47944 5.52779C4.47237 5.33697 4.55233 5.18628 4.59944 5.1057C4.64734 5.02379 4.71384 4.93072 4.77801 4.84093C4.78136 4.83624 4.78471 4.83156 4.78804 4.82689L8.08623 0.209421C8.21971 0.0225533 8.46332 -0.0493662 8.67688 0.0350447Z",
    fill: "#0060CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolid0);
export default __webpack_public_path__ + "static/media/solid0.6a66074b2740a18c6495cb995724a76a.svg";
export { ForwardRef as ReactComponent };